export enum RiskLevel {
  HighRisk = "HighRisk",
  Issue = "Issue",
  LowRisk = "LowRisk",
  MediumRisk = "MediumRisk",
  None = "None",
}
